import * as AuthStore from '@/util/AuthStore';

export function getStorageCorp() {
    const storageCorpData = AuthStore.getStorageCorps();
    // console.log(storageCorpData);
    const currentCorpId = storageCorpData?.cid;
    const corps = storageCorpData?.corps ?? [];
    const hasMoreCorp = corps.length > 1;

    return {currentCorpId, corps, hasMoreCorp};
}

export function getCurrentCorpName() {
    const {currentCorpId, corps, hasMoreCorp} = getStorageCorp();

    if (!hasMoreCorp) {
        return null;
    }

    const corp = corps.find(({corpId}) => corpId === currentCorpId) ?? {};

    return corp?.corpName;
}
